/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Visa_Eb1_Point_2_TextInputs */

const en_visa_eb1_point_2_text = /** @type {(inputs: Visa_Eb1_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Our role is to identify the strongest available evidence and present it clearly so the case is framed around the client's actual profile.`)
};

const pt_visa_eb1_point_2_text = /** @type {(inputs: Visa_Eb1_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nosso papel é identificar a evidência disponível mais forte e apresentá-la claramente para que o caso seja enquadrado em torno do perfil real do cliente.`)
};

const es_visa_eb1_point_2_text = /** @type {(inputs: Visa_Eb1_Point_2_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nuestro papel es identificar la evidencia disponible más sólida y presentarla claramente para que el caso se enmarque en torno al perfil real del cliente.`)
};

/**
* | output |
* | --- |
* | "Our role is to identify the strongest available evidence and present it clearly so the case is framed around the client's actual profile." |
*
* @param {Visa_Eb1_Point_2_TextInputs} inputs
* @param {{ locale?: "en" | "pt" | "es" }} options
* @returns {LocalizedString}
*/
export const visa_eb1_point_2_text = /** @type {((inputs?: Visa_Eb1_Point_2_TextInputs, options?: { locale?: "en" | "pt" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Visa_Eb1_Point_2_TextInputs, { locale?: "en" | "pt" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt") return pt_visa_eb1_point_2_text(inputs)
	if (locale === "es") return es_visa_eb1_point_2_text(inputs)
	return en_visa_eb1_point_2_text(inputs)
});